import Head from 'next/head'
import NumericIcon from '../components/NumericIcon'
import Link from 'next/link'
import Image from 'next/image'
import howItWorks1 from '../public/images/how-it-works-1.png'
import howItWorks2 from '../public/images/how-it-works-2.png'
import howItWorks3 from '../public/images/how-it-works-3.png'
import howItWorks4 from '../public/images/how-it-works-4.png'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import PopularSubjectsHero from '../components/PopularSubjectsHero'
import HowItWorksHero from '../components/HowItWorksHero'

export default function HowItWorks() {
  return <>
    <Head>
      <title>How Tutorspot Works | Online and In-person tutoring | Tutorspot</title>
    </Head>
    <HowItWorksHero />

    <div className="bg-white">
      <Container className="mt-3">
        <Row>
          <Col xs={12} md={9} className="mx-md-auto">
            <Row className="mb-5">
              <div className="col-xs-12 col-md-7">
                <NumericIcon number={1} />
                <h3>
                  Use our simple
                  {' '}
                  <Link href="tutors/search">search</Link>
                  {' '}
                  tools to find your perfect tutor
                </h3>
              </div>
              <div className="col-xs-12 col-md-5 pt-5">
                <Image
                  src={howItWorks1}
                  className="shadow-lg w-100"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    width: "auto"
                  }} />
              </div>
            </Row>

            <Row className="mb-5">
              <div className="col-xs-12 col-md-7 order-md-1">
                <NumericIcon number={2} />
                <h3>Message tutors directly from Tutorspot to discuss details and confirm scheduling</h3>
              </div>
              <div className="col-xs-12 col-md-5 pt-5">
                <Image
                  src={howItWorks2}
                  className="shadow-lg w-100"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    width: "auto"
                  }} />
              </div>
            </Row>

            <Row className="mb-5">
              <div className="col-xs-12 col-md-7">
                <NumericIcon number={3} />
                <h3>Begin lessons with your chosen tutor either in-person or online</h3>
              </div>
              <div className="col-xs-12 col-md-5 pt-5">
                <Image
                  src={howItWorks3}
                  className="shadow-lg w-100"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    width: "auto"
                  }} />
              </div>
            </Row>

            <Row className="mb-5">
              <div className="col-xs-12 col-md-7 order-md-1">
                <NumericIcon number={4} />
                <h3>Payment is taken automatically after each lesson. Simple!</h3>
              </div>
              <div className="col-xs-12 col-md-5 pt-5">
                <Image
                  src={howItWorks4}
                  className="shadow-lg w-100"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    width: "auto"
                  }} />
              </div>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>

    <PopularSubjectsHero />
  </>
}
